document.addEventListener('alpine:init', function () {
  Alpine.data('ctrSubscriptionPopup', function () {
    return {
      isOpen: false,
      bypassed: false,
      upgradeSource: null,

      init: function () {
        var self = this;
        window.ctrSubscriptionPopup = {
          intercept: function () {
            return self.intercept();
          },
          applyToItems: function (items) {
            return self.applyToItems(items);
          },
        };
      },

      intercept: function () {
        if (this.bypassed) {
          this.bypassed = false;
          return false;
        }

        this.isOpen = true;
        return true;
      },

      close: function () {
        this.isOpen = false;
      },

      applyToItems: function (items) {
        if (!this.upgradeSource || !items || !items.length) return items;

        var source = this.upgradeSource;
        this.upgradeSource = null;

        items.forEach(function (item) {
          item.properties = item.properties || {};
          item.properties._subscription_upgrade_source = source;
        });

        return items;
      },

      selectSubscription: function () {
        var subRadio = document.querySelector('input[name="purchase-option"][value="subscription"]');
        if (subRadio) subRadio.checked = true;

        var stickyToggle = document.querySelector('.sticky-toggle-btn');
        if (stickyToggle && stickyToggle.classList.contains('is-onetime')) {
          stickyToggle.click();
        }
      },

      clickAtc: function () {
        var btn =
          document.querySelector('.bundle-product-atc') ||
          document.querySelector('.bundle-sticky-atc') ||
          document.querySelector('.product-atc') ||
          document.querySelector('.product__sticky__bar-add-cart');

        if (btn) btn.click();
      },

      continueAtc: function () {
        this.bypassed = true;
        this.close();
        this.clickAtc();
      },

      subscribe: function () {
        this.upgradeSource = 'popup';
        this.selectSubscription();
        this.continueAtc();
      },

      continueOnetime: function () {
        this.upgradeSource = null;
        this.continueAtc();
      },
    };
  });
});
